export default "__VITE_ASSET__D5f4iuwf__"